const PriorAuthTable = () => (
  <>
    <section id="preAuthTable">
      <div className="bg-white">
        <div className="max-w-screen-xl px-4 py-12 mx-auto sm:px-6 lg:px-8">
          <div className="py-8 lg:grid lg:grid-cols-4 lg:gap-8 lg:items-center">
            <div className="lg:col-span-3">
              <h2 className="text-4xl tracking-tight font-extralight text-darkBlue">
                Services Requiring Prior Authorization
              </h2>
              <ul className="list-disc ml-4 mt-6 text-grey font-[sans-serif]">
                <li>
                  Services being performed in the Emergency Department do NOT
                  require prior authorization.
                </li>
                <li>
                  ALL services being performed or ordered by a non-participating
                  provider REQUIRES prior authorization for members with EPO
                  coverage.
                </li>
                <li>
                  Admission to an inpatient facility, intensive outpatient
                  (IOP), partial hospitalization (PHP), and residential
                  treatment center (RTC) that are not directly from an ER.
                  Emergency screening and stabilization services are not subject
                  to authorization.
                </li>
                <li>
                  See below for additional services requiring authorization.
                </li>
              </ul>
            </div>
            <div className="lg:col-span-1">
              <p className="inline-block mt-6 font-bold">
                This list may not be all-inclusive. Please call if you are
                uncertain whether a referral is necessary, or a provider is
                participating.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section>
      <div className="max-w-screen-xl px-4 py-12 mx-auto sm:px-6 lg:px-8">
        <h2 className="py-8 text-2xl text-center text-blue-dark md:text-4xl md:py-10">
          Services Requiring Authorization
        </h2>
        <table className="m-auto md:mb-8">
          <thead className="table-border-body">
            <tr className="text-left font-[sans-serif]">
              <th className="w-1/3 h-24 pl-4 text-base md:text-2xl text-blue">
                Authorization Service Category
              </th>
              <th className="w-1/3 h-24 text-base md:text-2xl text-green">
                Comments
              </th>
            </tr>
          </thead>
          <tbody className="blue-border-body text-grey">
            <tr className="border-white border-y-2">
              <td className="py-10 md:pl-4 lg:pl-4 xl:pl-4 md:pr-4 lg:pr-4 xl:pr-4 bg-torquoise">
                <p className="text-base font-bold">Admissions</p>
              </td>
              <td className="py-10 md:pl-4 lg:pl-4 xl:pl-4 md:pr-4 lg:pr-4 xl:pr-4 bg-sandWhite">
                <p className="tex-base">
                  <strong>ALL</strong> planned or scheduled inpatient
                  admissions, includes medical, behavioral health, surgical
                  admissions, hospice, including transfers from one facility to
                  another
                </p>
              </td>
            </tr>
            <tr>
              <td className="py-10 md:pl-4 lg:pl-4 xl:pl-4 md:pr-4 lg:pr-4 xl:pr-4">
                <p className="text-base font-bold">Acute Rehabilitation</p>
              </td>
              <td className="py-10 md:pl-4 lg:pl-4 xl:pl-4 md:pr-4 lg:pr-4 xl:pr-4">
                <p className="tex-base">
                  <strong>ALL</strong> Inpatient Rehabilitation, Long Term Acute
                  Care Hospital, Skilled Nursing Facilities
                </p>
              </td>
            </tr>
            <tr className="border-white border-y-2">
              <td className="md:pl-4 lg:pl-4 xl:pl-4 md:pr-4 lg:pr-4 xl:pr bg-torquoise">
                <p className="text-base font-bold">
                  Ambulance or Air/Water Transport
                </p>
              </td>
              <td className="py-10 md:pl-4 lg:pl-4 xl:pl-4 md:pr-4 lg:pr-4 xl:pr-4 bg-sandWhite">
                <p className="text-base">
                  Ambulance or Air/Water Ambulance (Non-Emergent transport or
                  transfer generally not covered)
                </p>
              </td>
            </tr>
            <tr>
              <td className="py-10 md:pl-4 lg:pl-4 xl:pl-4 md:pr-4 lg:pr-4 xl:pr-4">
                <p className="text-base font-bold">
                  Any Experimental/ Investigational Services
                </p>
              </td>
              <td className="py-10 md:pl-4 lg:pl-4 xl:pl-4 md:pr-4 lg:pr-4 xl:pr-4">
                <p className="text-base">
                  Experimental/ Investigational medical and surgical procedures,
                  equipment, and medications
                </p>
              </td>
            </tr>
            <tr className="border-white border-y-2">
              <td className="py-10 md:pl-4 lg:pl-4 xl:pl-4 md:pr-4 lg:pr-4 xl:pr-4 bg-torquoise">
                <p className="text-base font-bold">
                  Behavioral Health Services
                </p>
              </td>
              <td className="md:pl-4 lg:pl-4 xl:pl-4 md bg-torquoise:pr-4 lg:pr-4 xl:pr-4 py- bg-sandWhite">
                <p className="text-base">Behavioral Health Services</p>
                <ul className="pl-4 md:list-disc md:pl-8">
                  <li>Applied Behavioral Analysis (ABA)</li>
                  <li>Electroconvulsive Therapy (ECT) Applied</li>
                  <li>Neuropsychological and Psychological Testing</li>
                  <li>Intensive outpatient program (IOP)</li>
                  <li>Partial Hospitalization (PHP)</li>
                  <li>Residential treatment center (RTC)</li>
                </ul>
              </td>
            </tr>
            <tr>
              <td className="py-10 md:pl-4 lg:pl-4 xl:pl-4 md:pr-4 lg:pr-4 xl:pr-4">
                <p className="text-base font-bold">Clinical trials</p>
              </td>
              <td className="py-10 md:pl-4 lg:pl-4 xl:pl-4 md:pr-4 lg:pr-4 xl:pr-4">
                <p className="text-base">
                  All clinical trials including cancer and clinical innovation
                </p>
              </td>
            </tr>
            <tr className="border-white border-y-2">
              <td className="py-10 md:pl-4 lg:pl-4 xl:pl-4 md:pr-4 lg:pr-4 xl:pr-4 bg-torquoise">
                <p className="text-base font-bold">Dental</p>
              </td>
              <td className="py-10 md:pl-4 lg:pl-4 xl:pl-4 md:pr-4 lg:pr-4 xl:pr-4 bg-sandWhite">
                <p className="text-base">
                  All dental related services. Generally not covered.
                </p>
              </td>
            </tr>
            <tr>
              <td className="py-10 md:pl-4 lg:pl-4 xl:pl-4 md:pr-4 lg:pr-4 xl:pr-4">
                <p className="text-base font-bold">Dialysis</p>
              </td>
              <td className="py-10 md:pl-4 lg:pl-4 xl:pl-4 md:pr-4 lg:pr-4 xl:pr-4">
                <p className="text-base">All services</p>
              </td>
            </tr>
            <tr className="border-white border-y-2">
              <td className="py-10 md:pl-4 lg:pl-4 xl:pl-4 md:pr-4 lg:pr-4 xl:pr-4 bg-torquoise">
                <p className="text-base font-bold">
                  Durable Medical Equipment &#38; Prosthetics
                </p>
              </td>
              <td className="md:pl-4 lg:pl-4 xl:pl-4 md:pr-4 lg:pr-4 xl:pr bg-sandWhite">
                <ul className="text-base md:list-disc md:pl-4">
                  <li>All DME Rental</li>
                  <li>Some items require authorization.</li>
                </ul>
              </td>
            </tr>
            <tr>
              <td className="py-10 md:pl-4 lg:pl-4 xl:pl-4 md:pr-4 lg:pr-4 xl:pr-4">
                <p className="text-base font-bold">Hematology and Oncology</p>
              </td>
              <td className="md:pl-4 md:pr-4 lg:pr-4 xl:pr">
                <p className="text-base">
                  Cancer treatment including chemotherapy, radiation, and
                  surgery; Submit treatment plan as soon as known to facilitate
                  rapid approval of necessary services
                </p>
              </td>
            </tr>
            <tr className="border-white border-y-2">
              <td className="py-10 md:pl-4 lg:pl-4 xl:pl-4 md:pr-4 lg:pr-4 xl:pr-4 bg-torquoise">
                <p className="text-base font-bold">
                  Imaging Advanced &#38; Diagnostic Procedures
                </p>
              </td>
              <td className="md:pl-4 md:pr-4 lg:pr-4 xl:pr bg-sandWhite">
                <p className="text-base">
                  Arteriogram, Angiograms, CT/CTA scans, MRIs/MRAs, PET scans
                  (exception breast MRI doesn’t require prior authorization)
                </p>
              </td>
            </tr>
            <tr>
              <td className="py-10 md:pl-4 lg:pl-4 xl:pl-4 md:pr-4 lg:pr-4 xl:pr-4">
                <p className="text-base font-bold">
                  Gene Therapy and Molecular Diagnostic Testing
                </p>
              </td>
              <td className="md:pl-4 md:pr-4 lg:pr-4 xl:pr">
                <ul className="py-10 text-base md:list-disc md:pl-4">
                  <li>
                    Cancer treatment including chemotherapy, radiation, and
                    surgery; Submit treatment plan as soon as known to
                    facilitate rapid approval of necessary services
                  </li>
                  <li>All gene therapy</li>
                  <li>All molecular diagnostic testing and genetic testing</li>
                  <li>
                    In network lab: Quest Diagnostics and Bioreference (see
                    website for up to date in network provider information)
                  </li>
                </ul>
              </td>
            </tr>
            <tr className="border-white border-y-2">
              <td className="py-10 md:pl-4 lg:pl-4 xl:pl-4 md:pr-4 lg:pr-4 xl:pr-4 bg-torquoise">
                <p className="font-bold">
                  Home Services* <br /> (plan specific benefit)
                </p>
                <p className="pt-6 text-base">
                  In network home health: see provider <br /> directory for up
                  to date information
                </p>
              </td>
              <td className="md:pl-4 md:pr-4 lg:pr-4 xl:pr bg-sandWhite">
                <ul className="py-10 text-base md:list-disc md:pl-4">
                  <li>
                    Home care: skilled nursing, non skilled nursing, extended
                    home care, hemodialysis, home medical visits, ST/OT/OT
                    services
                  </li>
                  <li>
                    Home Infusion therapy services: hydration, nutrition,
                    medications including antibiotics
                  </li>
                  <li>
                    Hospice services (inpatient and home services after first 6
                    months)
                  </li>
                  <li>
                    Medical foods or enteral nutrition: oral foods generally not
                    a covered benefit
                  </li>
                </ul>
              </td>
            </tr>
            <tr>
              <td className="py-10 md:pl-4 lg:pl-4 xl:pl-4 md:pr-4 lg:pr-4 xl:pr-4">
                <p className="text-base font-bold">
                  The following surgeries when
                  <br /> performed in an Inpatient,
                  <br /> Outpatient, or office location.
                </p>
              </td>
              <td className="md:pl-4 md:pr-4 lg:pr-4 xl:pr">
                <ul className="py-10 text-base md:list-disc md:pl-4">
                  <li>Back injections (ESI, RFA, MBB, Facet, ect.)</li>
                  <li>Bariatric Surgery</li>
                  <li>Blepharoplasty - Brow Lift</li>
                  <li>Breast Procedures</li>
                  <li>
                    All Cosmetic surgery: not covered when performed to improve
                    appearance
                  </li>
                  <li>All infusions</li>
                  <li>Hyperbaric oxygen therapy</li>
                  <li>Photodynamic therapy</li>
                  <li>Spine Procedures</li>
                  <li>Neurostimulators</li>
                  <li>Ophthalmologic procedures</li>
                  <li>Some Joint Surgeries (Knee, Hip, Shoulder)</li>
                  <li>
                    Some Ear Nose and Throat, Oral-Maxo facial, Integumentary,
                    Gastrointestinal, Female and Male Genital, Reproductive,
                    Ophthalmologic, Orthopedic, Neurological, Fertility
                  </li>
                  <li>CAR-T Cell therapy procedures</li>
                </ul>
              </td>
            </tr>
            <tr className="border-white border-y-2">
              <td className="py-10 md:pl-4 lg:pl-4 xl:pl-4 md:pr-4 lg:pr-4 xl:pr-4 bg-torquoise">
                <p className="font-bold">
                  Miscellaneous, Unlisted Codes <br />
                  and T Codes
                </p>
              </td>
              <td className="md:pl-4 md:pr-4 lg:pr-4 xl:pr bg-sandWhite">
                <p className="text-base">
                  Miscellaneous, unlisted codes and T codes are not covered,
                  unless otherwise stated in the provider’s contract.
                </p>
              </td>
            </tr>
            <tr className="border-white border-y-2">
              <td className="py-10 md:pl-4 lg:pl-4 xl:pl-4 md:pr-4 lg:pr-4 xl:pr-4">
                <p className="font-bold">
                  Physician Administered Drugs:
                  <br />
                  Some Specialty Rx/Infusions
                </p>
              </td>
              <td className="md:pl-4 md:pr-4 lg:pr-4 xl:pr">
                <p className="text-base">
                  Most drugs require prior authorization eg. biologicals,
                  supportive care drugs, immunoglobulins, viscosupplementation,
                  etc. Please see the list below for common examples, call Evry
                  Health to confirm if physician administered drug is not listed
                  below.
                </p>
              </td>
            </tr>
            <tr className="border-white border-y-2">
              <td className="py-10 md:pl-4 lg:pl-4 xl:pl-4 md:pr-4 lg:pr-4 xl:pr-4 bg-torquoise">
                <p className="text-base font-bold">
                  Plan Specific Provisions:
                  <br /> Check member benefit/
                  <br />
                  eligibility for eligibility.
                </p>
              </td>
              <td className="py-8 md:pl-4 lg:pl-4 xl:pl-4 md:pr-4 lg:pr-4 xl:pr bg-sandWhite">
                <ul className="text-base md:list-disc md:pl-4">
                  <li>
                    Child Developmental Delays for rehabilitative and
                    habilitative services
                  </li>
                  <li>
                    Home Health which includes a limit to 60 visits per calendar
                    year combined modalities
                  </li>
                  <li>
                    Treatment of Mental or Emotional Illness or Disorder when
                    confined to a hospital or Psychiatric Day Treatment Facility
                  </li>
                  <li>In-Vitro Fertilization/Fertility</li>
                  <li>Speech and Hearing Assistance</li>
                  <li>Bariatric Surgery</li>
                  <li>Transgender Services</li>
                </ul>
              </td>
            </tr>
            <tr className="border-white border-y-2">
              <td className="py-10 md:pl-4 lg:pl-4 xl:pl-4 md:pr-4 lg:pr-4 xl:pr-4">
                <p className="font-bold">
                  Transplants and Transplant
                  <br /> related services
                </p>
              </td>
              <td className="md:pl-4 md:pr-4 lg:pr-4 xl:pr">
                <p className="text-base">All Transplants</p>
                <ul className="pt-6 ml-8 list-disc">
                  <li>
                    Includes Transplant Evaluations, Pre- & Post- Operative
                    Services/Care
                  </li>
                </ul>
              </td>
            </tr>
            <tr className="border-white border-y-2">
              <td className="py-10 md:pl-4 lg:pl-4 xl:pl-4 md:pr-4 lg:pr-4 xl:pr-4 bg-torquoise">
                <p className="text-base font-bold">Reporting</p>
              </td>
              <td className="py-8 md:pl-4 lg:pl-4 xl:pl-4 md:pr-4 lg:pr-4 xl:pr bg-sandWhite">
                <p>
                  Evry tracks the number of prior authorization requests
                  received and makes available prior authorization approval and
                  denial rates on a yearly basis. These{' '}
                  <a
                    href="https://api.evryhealth.com/api/v1/Marketing/GetFileContent?id=CE2E78AF-B94C-4CDC-9352-2DA91978BCC3"
                    className="font-bold text-green"
                  >
                    statistics
                  </a>{' '}
                  on the previous year are available 2nd quarter of current
                  year.{' '}
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  </>
)

export default PriorAuthTable
